import { render, staticRenderFns } from "./InputItem.vue?vue&type=template&id=53b52fba&scoped=true"
import script from "./InputItem.vue?vue&type=script&lang=js"
export * from "./InputItem.vue?vue&type=script&lang=js"
import style0 from "./InputItem.vue?vue&type=style&index=0&id=53b52fba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b52fba",
  null
  
)

export default component.exports